import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";
import { useSocketConnection } from "@/context/SocketContext";
import { SocketConnectionStatus } from "@/model/interface/SocketConnection";

const SHOW_AFTER_MS = 3000;

const LABELS: Record<Exclude<SocketConnectionStatus, "connected">, string> = {
  connecting: "Connecting...",
  reconnecting: "Reconnecting...",
  offline: "Offline",
};

export function ConnectionStatusPill() {
  const { status, disconnectedAt } = useSocketConnection();
  const [visible, setVisible] = useState(false);
  const shownAfterDropRef = useRef(false);

  useEffect(() => {
    if (status === "connected") {
      if (shownAfterDropRef.current) {
        toast.success("Connection restored");
      }
      shownAfterDropRef.current = false;
      setVisible(false);
      return;
    }
    const downSince = disconnectedAt ?? Date.now();
    const remaining = Math.max(SHOW_AFTER_MS - (Date.now() - downSince), 0);
    const timer = setTimeout(() => {
      shownAfterDropRef.current = disconnectedAt !== null;
      setVisible(true);
    }, remaining);
    return () => clearTimeout(timer);
  }, [status, disconnectedAt]);

  if (!visible || status === "connected") {
    return null;
  }

  return (
    <span className={cn(status === "offline" ? "status-pill-neutral" : "status-pill-warning", "shrink-0")}>
      <span className="h-2 w-2 rounded-full bg-current" />
      {LABELS[status]}
    </span>
  );
}
